// extracted by mini-css-extract-plugin
export default {"content":"styles_content__ee3hz","layout":"styles_layout__vuuRa","info":"styles_info__weI15"};